var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['catalog-tags']},_vm._l((_vm.sections),function(section,index){return _c('div',{key:index,class:[
      'catalog-tags__item',
      {
        'catalog-tags__item_selected': _vm.checkSelected(section.code)
      }
    ],on:{"click":function($event){$event.preventDefault();return _vm.selectSection(section.code)}}},[_c('a',[_vm._v(_vm._s(section.name))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }